module.exports = __webpack_public_path__ + "i18n/fr.8187d62fb896e597b3ca807a43079e15.json";